import React from 'react';
import PropTypes from 'prop-types';
import SpecRastitelno from './SpecRastitelno';
import {connect} from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Notification from "../../../common/Notification";
import {bindActionCreators, compose} from "redux";
import {getUser} from "../../../redux/user/reducer";
import {fetchSpecRastitelnoById, updateSpecRastitelnoRequest} from "../../../redux/specRastitelno/fetch";
import {getSpecRastitelno} from "../../../redux/specRastitelno/reducer";
import {cleanJsonSpecifikacija} from "../../../redux/helpers";
import {withStyles} from "@material-ui/core/styles";
import globalStyles from "../../styles";
import {fetchLookups} from "../../../redux/lookup/fetch";
import {getLookupMap} from "../../../redux/lookup/reducer";

export class EditSpecRastitelno extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.updateSpecRastitelno = this.updateSpecRastitelno.bind(this);
        this.redirectToSpecRastitelnoList = this.redirectToSpecRastitelnoList.bind(this);
        this.state = {notify: false, message: '', error: false};
    }

    componentDidMount() {
        const {fetchSpecRastitelnoById, fetchLookups} = this.props;
        fetchSpecRastitelnoById(this.props.match.params.id);
        fetchLookups();
    }

    updateSpecRastitelno(values) {
        const id = values.id
        let newValues = cleanJsonSpecifikacija(JSON.parse(JSON.stringify(values)), true);
        this.props.updateSpecRastitelnoRequest(newValues, id)
        this.showNotification("Успешно зачувано");
    }

    redirectToSpecRastitelnoList() {
        this.props.history.push(`/SpecRastitelnoList`);
    }

    showNotification = (msg, err) => {
        if (err)
            this.setState({notify: true, message: msg, error: true});
        else
            this.setState({notify: true, message: msg, error: false});
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    render() {
        const {notify, message, error} = this.state;
        const {classes} = this.props;

        return (
            <div>
                <Card style={{boxShadow: "none", border: 0}}>
                    <CardContent className={classes.noPrint}>
                        <h1>Измени спецификација растително</h1>
                    </CardContent>
                    {this.props.id && this.props.specRastitelno &&
                        <SpecRastitelno
                            pouId={this.props.specRastitelno.specRastitelno.id}
                            specRastitelno={this.props.specRastitelno.specRastitelno}
                            onSubmit={this.updateSpecRastitelno}
                            onCancel={this.redirectToSpecRastitelnoList}
                            editMode
                            lookupData={this.props.lookupData}
                        />
                    }
                </Card>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        id: id,
        specRastitelno: getSpecRastitelno(state),
        user: getUser(state),
        lookupData: getLookupMap(state)
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSpecRastitelnoById,
        updateSpecRastitelnoRequest,
        fetchLookups
    }, dispatch)
}


EditSpecRastitelno.propTypes = {
    actions: PropTypes.object.isRequired,
    dispatch: PropTypes.func
};

EditSpecRastitelno.contextTypes = {
    router: PropTypes.object
};
export default compose(
    withStyles(globalStyles),
    connect(mapStateToProps, mapDispatchToProps)
)(EditSpecRastitelno);